import React from 'react';
import SpinnerIcon from '../../assets/spinner.svg';
import './index.css';

const LoadingSpinner = ({ caption, height, className }) => {

  return (
    <div className={`loading-spinner-wrapper ${className || ''}`} style={{ height }}>
      <div className="spinner" >
        <SpinnerIcon />
      </div>
      {caption && <div className="spinner-caption">{caption}</div>}
    </div>
  );
}

export default LoadingSpinner;
